
import { Category, Resource } from '../types/resource';

export const defaultCategories: Category[] = [
  {
    id: '2',
    name: 'Email Protection',
    description: 'Protect yourself from email threats',
    icon: 'mail',
    imageUrl: '/lovable-uploads/722eea2a-f81d-4b2a-9014-f0aa7f25bddb.png'
  },
  {
    id: '4',
    name: 'Security Training',
    description: 'Best practices for keeping your data secure',
    icon: 'shield'
  },
  {
    id: '1',
    name: 'VOIP Training',
    description: 'Learn how to use our VOIP phone systems',
    icon: 'phone'
  },
  {
    id: '3',
    name: 'Onboarding Resources',
    description: 'Resources for new employees',
    icon: 'users'
  }
];

export const defaultResources: Resource[] = [
  {
    id: '1',
    title: 'VOIP Phone Setup Guide',
    description: 'Learn how to set up your new office phone',
    link: '#',
    imageUrl: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d',
    categoryId: '1',
    type: 'document',
    subTopics: [
      {
        id: '1-1',
        title: 'Phone Hardware Installation',
        description: 'How to connect and configure your physical phone',
        link: '#'
      },
      {
        id: '1-2',
        title: 'Voicemail Configuration',
        description: 'Setting up and managing your voicemail',
        link: '#'
      },
      {
        id: '1-3',
        title: 'Call Forwarding',
        description: 'How to setup call forwarding to your mobile device',
        link: '#'
      }
    ]
  },
  {
    id: '2',
    title: 'Making Conference Calls',
    description: 'Step-by-step guide for setting up conference calls',
    link: '#',
    imageUrl: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158',
    categoryId: '1',
    type: 'video',
    subTopics: [
      {
        id: '2-1',
        title: 'Scheduling Group Calls',
        description: 'How to schedule and invite participants',
        link: '#'
      },
      {
        id: '2-2',
        title: 'Managing Participants',
        description: 'Controls for muting, removing, and adding participants',
        link: '#'
      }
    ]
  },
  {
    id: '3',
    title: 'Email Protection',
    description: 'Learn how to spot and avoid phishing attempts',
    link: '#',
    imageUrl: '/lovable-uploads/722eea2a-f81d-4b2a-9014-f0aa7f25bddb.png',
    categoryId: '2',
    type: 'document',
    subTopics: [
      {
        id: '3-1',
        title: 'Recognizing Phishing Attempts',
        description: 'Learn about the latest phishing strategies',
        link: '#'
      },
      {
        id: '3-2',
        title: 'Reporting Suspicious Emails',
        description: 'How to report potential phishing attempts',
        link: '#'
      },
      {
        id: '3-3',
        title: 'Phishing Simulation Training',
        description: 'Practice identifying phishing emails',
        link: '#'
      }
    ]
  },
  {
    id: '4',
    title: 'Email Spam Protection',
    description: 'How to send encrypted emails when handling sensitive information',
    link: '#',
    imageUrl: '/lovable-uploads/722eea2a-f81d-4b2a-9014-f0aa7f25bddb.png',
    categoryId: '2',
    type: 'video',
    subTopics: [
      {
        id: '4-1',
        title: 'Email Security Standards',
        description: 'Overview of email encryption technologies',
        link: '#',
        htmlEmbed: '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/516d9690-ab05-44e2-855c-1d266c3567bd" loading="lazy" title="Synthesia video player - Enhancing Your Email Security with Domitek SpamFilter" allowfullscreen allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>'
      },
      {
        id: '4-2',
        title: 'Setting Up Email Encryption',
        description: 'Step-by-step guide to enable encryption',
        link: '#'
      },
      {
        id: '4-3',
        title: 'Managing Quarantine Emails',
        description: 'How to review and manage quarantined emails',
        link: '#',
        htmlEmbed: '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/47e513ba-24f1-40f8-82ac-8825d135bd94" loading="lazy" title="Synthesia video player - Managing Quarantine Emails" allowfullscreen allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>'
      }
    ]
  },
  {
    id: '5',
    title: 'Company Handbook',
    description: 'Everything you need to know as a new employee',
    link: '#',
    imageUrl: 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b',
    categoryId: '3',
    type: 'document'
  },
  {
    id: '6',
    title: 'Benefits Overview',
    description: 'Learn about your employee benefits',
    link: '#',
    imageUrl: 'https://images.unsplash.com/photo-1518770660439-4636190af475',
    categoryId: '3',
    type: 'link'
  },
  {
    id: '7',
    title: 'Password Best Practices',
    description: 'How to create and manage secure passwords',
    link: '#',
    imageUrl: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6',
    categoryId: '4',
    type: 'document'
  },
  {
    id: '8',
    title: 'Two-Factor Authentication Setup',
    description: 'Setting up 2FA for your company accounts',
    link: '#',
    imageUrl: 'https://images.unsplash.com/photo-1518770660439-4636190af475',
    categoryId: '4',
    type: 'video'
  }
];
